import { Title } from "@vshp/ui-components";
import teachersBg from "../../../public/images/teachers.jpg";

import Slider from "../utils/Slider";
import Image from "next/image";

function TeachersProgram({ teachers }) {
  const settings = {
    infinite: true,
  };

  return (
    <section className="page__block page__block_cover">
      <Image className="page__block-img" src={teachersBg} alt="Преподаватели" placeholder="blur" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          Преподаватели
        </Title>

        <Slider className="slider-description" sliderSettings={settings}>
          {teachers.map((teacher, key) => (
            <div className="slider__item" key={key}>
              <div className="slider-description__item teachers-slider__item">
                <div className="slider-description__header teachers-slider__header">
                  <img className="slider-description__photo teachers-slider__photo" src={teacher.attributes.photo.origin} alt={teacher.attributes.name} />
                  <div className="slider-description__name teachers-slider__name">{teacher.attributes.name}</div>
                  <div className="slider-description__post teachers-slider__post">
                    {teacher.attributes.position}
                    <br />
                    {teacher.attributes.organization}
                  </div>
                </div>
                <div className="slider-description__content teachers-slider__content" dangerouslySetInnerHTML={{ __html: teacher.attributes.description }}></div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default TeachersProgram;
